import hyperxCloud from "../media/hyperx-cloud.png";
import logitechF310 from "../media/logitech-f310.png";
import logitechG502 from "../media/logitech-g502.png";
import razerAudioMixer from "../media/razer-audio-mixer.png";
import razerBasilisk from "../media/razer-basilisk.png";
import razerBlackWidow from "../media/razer-black-widow.png";
import razerHammerhead from "../media/razer-hammerhead.png";
import razerKraken from "../media/razer-kraken-ultimate.png";
import razerTartarus from "../media/razer-tartarus.png";

export default {
  "hyperx-cloud": hyperxCloud,
  "logitech-f310": logitechF310,
  "logitech-g502": logitechG502,
  "razer-audio-mixer": razerAudioMixer,
  "razer-basilisk": razerBasilisk,
  "razer-black-widow": razerBlackWidow,
  "razer-hammerhead": razerHammerhead,
  "razer-kraken-ultimate": razerKraken,
  "razer-tartarus": razerTartarus,
};
